// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-dropdown {
  width: 90vw;
  height: 80px;
}
@media (min-width: 768px) {
  .container-dropdown {
    width: 43vw;
  }
}
@media (min-width: 1024px) {
  .container-dropdown {
    width: 25vw;
  }
}
@media (min-width: 1140px) {
  .container-dropdown {
    width: 27vw;
  }
}
.container-dropdown .container-input {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.container-dropdown .container-input .container-title-select {
  width: 223px;
}
.container-dropdown .container-input .container-title-select > label {
  color: #858585;
}
.container-dropdown .container-input .input-select {
  height: 46px;
  border: 1px solid #adadad;
  background-color: white;
  align-items: center;
  padding-left: 16px;
  padding-right: 20px;
  border-radius: 4px;
  margin-top: 12px;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
}
.container-dropdown .container-input .input-select > label {
  color: var(--sherpa-carbon-900);
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.2px;
}
.container-dropdown .container-input .ico-arrow-up,
.container-dropdown .container-input .ico-arrow-down {
  color: #0040a8;
  font-size: 18px;
}
.container-dropdown .container-menu {
  width: 81vw;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 64, 168, 0.4);
  border-radius: 4px;
  z-index: 100;
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin-top: 4px;
}
@media (min-width: 768px) {
  .container-dropdown .container-menu {
    width: 39vw;
  }
}
@media (min-width: 1024px) {
  .container-dropdown .container-menu {
    width: 22vw;
  }
}
@media (min-width: 1140px) {
  .container-dropdown .container-menu {
    width: 24.5vw;
  }
}
.container-dropdown .container-menu .container-checkbox {
  width: 100%;
  max-height: 235px;
  overflow-y: auto;
}
@media (min-width: 765px) {
  .container-dropdown .container-menu .container-checkbox {
    max-height: 335px;
  }
}
@media (min-width: 1024px) {
  .container-dropdown .container-menu .container-checkbox {
    max-height: 390px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/utils-ui/components/multi-select-dropdown/multi-select-dropdown.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;AACF;AAAE;EAHF;IAII,WAAA;EAGF;AACF;AAFE;EANF;IAOI,WAAA;EAKF;AACF;AAJE;EATF;IAUI,WAAA;EAOF;AACF;AANE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAQJ;AAPI;EACE,YAAA;AASN;AARM;EACE,cAAA;AAUR;AAPI;EACE,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AASN;AARM;EACE,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AAUR;AAPI;;EAEE,cAAA;EACA,eAAA;AASN;AANE;EACE,WAAA;EACA,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AAQJ;AAPI;EAXF;IAYI,WAAA;EAUJ;AACF;AATI;EAdF;IAeI,WAAA;EAYJ;AACF;AAXI;EAjBF;IAkBI,aAAA;EAcJ;AACF;AAbI;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;AAeN;AAdM;EAJF;IAKI,iBAAA;EAiBN;AACF;AAhBM;EAPF;IAQI,iBAAA;EAmBN;AACF","sourcesContent":[".container-dropdown {\n  width: 90vw;\n  height: 80px;\n  @media (min-width: 768px) {\n    width: 43vw;\n  }\n  @media (min-width: 1024px) {\n    width: 25vw;\n  }\n  @media (min-width: 1140px) {\n    width: 27vw;\n  }\n  .container-input {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    .container-title-select {\n      width: 223px;\n      > label {\n        color: #858585;\n      }\n    }\n    .input-select {\n      height: 46px;\n      border: 1px solid #adadad;\n      background-color: white;\n      align-items: center;\n      padding-left: 16px;\n      padding-right: 20px;\n      border-radius: 4px;\n      margin-top: 12px;\n      display: flex;\n      cursor: pointer;\n      justify-content: space-between;\n      > label {\n        color: var(--sherpa-carbon-900);\n        font-weight: normal;\n        font-size: 18px;\n        line-height: 24px;\n        letter-spacing: 0.2px;\n      }\n    }\n    .ico-arrow-up,\n    .ico-arrow-down {\n      color: #0040a8;\n      font-size: 18px;\n    }\n  }\n  .container-menu {\n    width: 81vw;\n    background: #ffffff;\n    box-shadow: 0px 4px 12px rgba(0, 64, 168, 0.4);\n    border-radius: 4px;\n    z-index: 100;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    margin-top: 4px;\n    @media (min-width: 768px) {\n      width: 39vw;\n    }\n    @media (min-width: 1024px) {\n      width: 22vw;\n    }\n    @media (min-width: 1140px) {\n      width: 24.5vw;\n    }\n    .container-checkbox {\n      width: 100%;\n      max-height: 235px;\n      overflow-y: auto;\n      @media (min-width: 765px) {\n        max-height: 335px;\n      }\n      @media (min-width: 1024px) {\n        max-height: 390px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
